import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../controls/buttons/button';
import type { SmartColumn } from './smartTable.types';
import "../../controls/fields/selectFieldNew.scss";
import CustomForm from '../../containers/custom-form';
import SelectField from '../../controls/fields/selectFieldNew';
import { ReactComponent as IconEditSVG } from "itd-common/assets/icons/edit.svg";
import { ReactComponent as IconDownloadSVG } from "itd-common/assets/icons/download.svg";

interface ToolbarProps {
  title?: string;
  onCustomize: () => void;
  onDownload?: () => void;
  onDownloadOptions?: Array<{ label: string; icon?: React.ReactNode; onClick: () => void }>;
  model: [any, (m: any) => void];
  onActiveColumnChange: (key: string) => void;
  filterControl: React.ReactNode; // control adaptable según filterKind
  visibleColumns: SmartColumn[];
  countData: number;
  isCustomizeTableAvailable?:boolean;
  extraFilter?: React.ReactNode;
  dateRangeType?: React.ReactNode;
}
const T_PREFIX: string = 'shared.smartTable.';
const SmartTableToolbar: React.FC<ToolbarProps> = ({ title = 'Resultados de búsqueda', onCustomize, onDownload, onDownloadOptions, model, onActiveColumnChange, filterControl, visibleColumns, countData, isCustomizeTableAvailable, extraFilter, dateRangeType }) => {
  const { t } = useTranslation();
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const hasDownloadOptions = (onDownloadOptions && onDownloadOptions.length > 0);

  const handleDownloadClick = () => {
    if (hasDownloadOptions) {
      setShowDownloadMenu((prev) => !prev);
      return;
    }
    onDownload?.();
  };

  const handleDownloadOptionClick = (action: () => void) => {
    setShowDownloadMenu(false);
    action();
  };

  return (
    <div className="st-toolbar personalize-list-columns">
      <div className="row st-header">
        <div className="col-md-6  d-flex align-items-center">
          <h3 className="st-title">{title}</h3>
        </div>
        <div className="col-md-6 d-flex align-items-center justify-content-end st-actions gap-1">
          {isCustomizeTableAvailable  && (<button
            disabled={countData <= 0}
            onClick={onCustomize} 
            className="containerDownload"><IconEditSVG /> <span>{t(`${T_PREFIX}customizeTable`)}</span></button>)}
          {(onDownload || hasDownloadOptions) && (
            <div className="st-download">
              <button
                disabled={countData <= 0}
                onClick={handleDownloadClick} className="containerDownload containerDownload--download"><IconDownloadSVG /> <span>{t(`${T_PREFIX}btnDownload`)}</span></button>
              {hasDownloadOptions && showDownloadMenu && (
                <div className="st-download-menu">
                  {onDownloadOptions?.map((option,icon) => (
                    <button
                      key={option.label}
                      type="button"
                      className="st-download-menu__button"
                      onClick={() => handleDownloadOptionClick(option.onClick)}
                    >
                      {option.icon && <span className="st-download-menu__icon">{option.icon}</span>}
                      {option.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {(extraFilter || dateRangeType) && (
        <div className="row st-extra-filter">
          {dateRangeType ? (
            <>
              <div className="col-md-6 d-flex align-items-center">{dateRangeType}</div>
              <div className="col-md-6">{extraFilter}</div>
            </>
          ) : (
            <div className="col-md-6">{extraFilter}</div>
          )}
        </div>
      )}
    </div>
  );
};
export default SmartTableToolbar;